module.exports = __webpack_public_path__ + "static/media/hockey-puck.2c12231e.svg";